<!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title" id="editCategoryModalLabel">
          {{ circulationStatusI18n?.titleI18n || 'Chỉnh sửa trạng thái lưu thông' }}
        </h5>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <form class="form-group odd" id="category_name_field_box">
          <label class="col-sm-3 control-label" for="name" id="category_name_display_as_box">
            <font style="vertical-align: inherit">
              {{ circulationStatusI18n?.nameI18n || 'Tên' }}
            </font>
            <span class="required">
              <font style="vertical-align: inherit">*</font>
            </span>
          </label>
          <div class="col-sm-9 col-md-6 col-lg-6" id="category_name_input_box">
            <input
              [(ngModel)]="model.name"
              value="{{ model.category_name }}"
              id="field-category_name"
              name="category_name"
              class="form-control"
              type="text"
              maxlength="99"
            />
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
          {{ circulationStatusI18n?.closeButtonI18n || 'Đóng' }}
        </button>
        <button (click)="edit()" type="button" class="btn btn-outline-info">
          <i class="fas fa-save"></i> 
          {{ circulationStatusI18n?.addButtonI18n || 'Lưu' }}
        </button>
      </div>